import * as React from "react";
import { SideType } from "../../store/types/store";

interface WallProps extends React.SVGProps<SVGSVGElement> {
    side: SideType
}

function WallIcon(props: WallProps) {
    const {side, ...rest} = props;

    if (side === 'front') {
        return (
           <svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
               <path d="M26.2015 1.10254H0.632996L8.98222 4.33806H18.1869L26.2015 1.10254Z" fill="white"/>
               <path
                  d="M0.632996 1.10254H26.2015M0.632996 1.10254V16.4437M0.632996 1.10254L8.98222 4.33806M26.2015 1.10254V16.4437M26.2015 1.10254L18.1869 4.33806M26.2015 16.4437C23.6372 15.4767 18.4443 13.5427 18.1869 13.5427M26.2015 16.4437H0.900446M0.632996 16.4437C0.632996 16.4837 0.729008 16.4807 0.900446 16.4437M0.632996 16.4437H0.900446M8.98222 4.33806H18.1869M8.98222 4.33806V13.5427M18.1869 4.33806V13.5427M18.1869 13.5427H8.98222M8.98222 13.5427C8.90818 13.5427 7.99373 13.8907 6.79513 14.3468C4.71937 15.1367 1.79138 16.251 0.900446 16.4437"
                  stroke="white"/>
           </svg>
        )
    }

    if (side === 'left') {
        return (
           <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
               <path
                  d="M0.632996 1.41748V16.7586H0.900446C1.79138 16.5659 4.71937 15.4517 6.79513 14.6618C7.99373 14.2057 8.90818 13.8577 8.98222 13.8577V4.653L0.632996 1.41748Z"
                  fill="white"/>
               <path
                  d="M0.632996 1.41748H26.2015M0.632996 1.41748V16.7586M0.632996 1.41748L8.98222 4.653M26.2015 1.41748V16.7586M26.2015 1.41748L18.1869 4.653M26.2015 16.7586C23.6372 15.7916 18.4443 13.8577 18.1869 13.8577M26.2015 16.7586H0.900446M0.632996 16.7586C0.632996 16.7986 0.729008 16.7957 0.900446 16.7586M0.632996 16.7586H0.900446M8.98222 4.653H18.1869M8.98222 4.653V13.8577M18.1869 4.653V13.8577M18.1869 13.8577H8.98222M8.98222 13.8577C8.90818 13.8577 7.99373 14.2057 6.79513 14.6618C4.71937 15.4517 1.79138 16.5659 0.900446 16.7586"
                  stroke="white"/>
           </svg>

        )
    }

    if (side === 'back') {
        return (
           <svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
               <path
                  d="M18.1869 13.1724H8.98222C8.90818 13.1724 7.99373 13.5204 6.79513 13.9765C4.71937 14.7664 1.79138 15.8806 0.900446 16.0733H26.2015C23.6372 15.1063 18.4443 13.1724 18.1869 13.1724Z"
                  fill="white"/>
               <path
                  d="M0.632996 0.732178H26.2015M0.632996 0.732178V16.0733M0.632996 0.732178L8.98222 3.9677M26.2015 0.732178V16.0733M26.2015 0.732178L18.1869 3.9677M26.2015 16.0733C23.6372 15.1063 18.4443 13.1724 18.1869 13.1724M26.2015 16.0733H0.900446M0.632996 16.0733C0.632996 16.1133 0.729008 16.1104 0.900446 16.0733M0.632996 16.0733H0.900446M8.98222 3.9677H18.1869M8.98222 3.9677V13.1724M18.1869 3.9677V13.1724M18.1869 13.1724H8.98222M8.98222 13.1724C8.90818 13.1724 7.99373 13.5204 6.79513 13.9765C4.71937 14.7664 1.79138 15.8806 0.900446 16.0733"
                  stroke="white"/>
           </svg>

        )
    }

    if (side === 'right') {
        return (
           <svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
               <path
                  d="M26.2015 16.3885V1.04736L18.1869 4.28288V13.4876C18.4443 13.4876 23.6372 15.4215 26.2015 16.3885Z"
                  fill="white"/>
               <path
                  d="M0.632996 1.04736H26.2015M0.632996 1.04736V16.3885M0.632996 1.04736L8.98222 4.28288M26.2015 1.04736V16.3885M26.2015 1.04736L18.1869 4.28288M26.2015 16.3885C23.6372 15.4215 18.4443 13.4876 18.1869 13.4876M26.2015 16.3885H0.900446M0.632996 16.3885C0.632996 16.4285 0.729008 16.4256 0.900446 16.3885M0.632996 16.3885H0.900446M8.98222 4.28288H18.1869M8.98222 4.28288V13.4876M18.1869 4.28288V13.4876M18.1869 13.4876H8.98222M8.98222 13.4876C8.90818 13.4876 7.99373 13.8355 6.79513 14.2917C4.71937 15.0816 1.79138 16.1958 0.900446 16.3885"
                  stroke="white"/>
           </svg>
        )
    }

    return (
       <svg width="27" height="17" viewBox="0 0 27 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
           <path d="M8.98222 4.17277H18.1869V13.3774H8.98222V4.17277Z" fill="white"/>
           <path fillRule="evenodd" clipRule="evenodd" d="M8.98222 13.3774H18.1869V4.17277H8.98222V13.3774Z" fill="white"/>
           <path d="M0.632996 0.937256H26.2015M0.632996 0.937256V16.2784M0.632996 0.937256L8.98222 4.17277M26.2015 0.937256V16.2784M26.2015 0.937256L18.1869 4.17277M26.2015 16.2784C23.6372 15.3114 18.4443 13.3774 18.1869 13.3774M26.2015 16.2784H0.900446M0.632996 16.2784C0.632996 16.3184 0.729008 16.3155 0.900446 16.2784M0.632996 16.2784H0.900446M8.98222 4.17277H18.1869M8.98222 4.17277V13.3774M18.1869 4.17277V13.3774M18.1869 13.3774H8.98222M8.98222 13.3774C8.90818 13.3774 7.99373 13.7254 6.79513 14.1815C4.71937 14.9715 1.79138 16.0857 0.900446 16.2784" stroke="white"/>
       </svg>
    );
}

export default WallIcon;
